export const GET_LIST_REJECT_PROFILE = 'GET_LIST_REJECT_PROFILE'
export const GET_LIST_REJECT_PROFILE_ERR = 'GET_LIST_REJECT_PROFILE_ERR'

export const RESET_LIST_REJECT_PROFILE = 'RESET_LIST_REJECT_PROFILE'

export const UPDATE_REJECT_CONDFILTERS = 'UPDATE_REJECT_CONDFILTERS'
export const RESET_REJECT_CONDFILTERS = 'RESET_REJECT_CONDFILTERS'